// --------------------------------------------------------------
// Created On: 2026-06-02
// Author: Zachary Thomas
//
// Last Modified: 2026-06-02
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./MotorVisual.module.scss";

// A data visualization for a motor.
export default function MotorVisual(): Component {
  return (
    <div className="row g-0">
      <div className="col-12 col-lg-6">
        <img className={styles.base} src="/productVisuals/motor/motor.png" alt="Motor Visualization" />
      </div>
    </div>
  );
}
